import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit'
import formInstanceReducer from './slices/formInstanceSlice'
import globalReduce from './slices/globalSlice'
import interstitialReducer from './slices/interstitialSlice'
import priceReducer from './slices/priceSlice'

export const listenerMiddleware = createListenerMiddleware()

export const startAppListening = listenerMiddleware.startListening;

const store = configureStore({
  reducer: {
    global: globalReduce,
    price: priceReducer,
    formInstance: formInstanceReducer,
    interstitial: interstitialReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddleware.middleware),
})

export default store
